<template>
  <div id="content" class="dlnkcalendar_waitings container-fluid">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <!-- Nav tabs -->
    <ul class="nav nav-tabs mt-2" role="tablist">
      <li class="nav-item" role="presentation">
        <a class="nav-link active" id="events-tab" data-toggle="tab" href="#events" role="tab" aria-controls="events"
           aria-selected="true">Évènements</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="books-tab" data-toggle="tab" href="#reservations" role="tab" aria-controls="reservations"
           aria-selected="true">Réservations</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="loans-tab" data-toggle="tab" href="#waitings" role="tab" aria-controls="loans"
           aria-selected="false">Liste d'attente</a>
      </li>
    </ul>

    <div class="tab-content">

      <div class="tab-pane active" id="events" role="tabpanel" aria-labelledby="events-tab">
        <!-- Pagination -->
        <div class="mt-2">
          <dlnkpagination
              :page="events_page"
              :page_count="events_page_count"
              @next_page="next_event_page()"
              @prev_page="prev_event_page()"
              @set_page="set_event_page($event)">
          </dlnkpagination>
        </div>
        <!-- End Pagination -->

        <!-- Waiting list -->
        <div class="tab-wrapper">

          <table class="table">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Événement</th>
              <th scope="col">Catégorie</th>
              <th scope="col">Date</th>
              <th scope="col">Stock initial</th>
              <th scope="col">Stock dispo</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="event in events" :key="events.id">
              <th scope="row">
                {{ event.id_event }}
              </th>
              <td>{{ event.event_name }}</td>
              <td>{{ event.category }}</td>
              <td>{{ event.event_start_date }}</td>
              <td>{{ event.event_max_dispo }}</td>
              <td>{{ event.availability }}</td>
            </tr>

            </tbody>
          </table>

        </div>
        <!-- End Loans  -->

        <!-- Pagination -->
        <dlnkpagination
            :page="events_page"
            :page_count="events_page_count"
            @next_page="next_event_page()"
            @prev_page="prev_event_page()"
            @set_page="set_event_page($event)">
        </dlnkpagination>
        <!-- End Pagination -->
      </div>

      <div class="tab-pane" id="reservations" role="tabpanel" aria-labelledby="books-tab">
        <!-- Pagination -->
        <div class="mt-2">
          <dlnkpagination
              :page="reservations_page"
              :page_count="reservations_page_count"
              @next_page="next_reservation_page()"
              @prev_page="prev_reservation_page()"
              @set_page="set_reservation_page($event)">
          </dlnkpagination>
        </div>
        <!-- End Pagination -->

        <!-- Waiting list -->
        <div class="tab-wrapper">

          <table class="table">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Événement</th>
              <th scope="col">Famille</th>
              <th scope="col">Prénom</th>
              <th scope="col">Nom</th>
              <th scope="col">Téléphone</th>
              <th scope="col">Age</th>
              <th scope="col">Date</th>
              <th scope="col">Action</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="reservation in reservations" :key="reservations.id">
              <th scope="row">
                {{ reservation.id }}
              </th>
              <td>{{ reservation.event }}</td>
              <td>{{ reservation.foyer }}</td>
              <td>{{ reservation.firstname }}</td>
              <td>{{ reservation.lastname }}</td>
              <td>{{ reservation.phone }}</td>
              <td>{{ reservation.age }}</td>
              <td>{{ reservation.created_at }}</td>
              <td>
                TODO
              </td>
            </tr>

            </tbody>
          </table>

        </div>
        <!-- End Loans  -->

        <!-- Pagination -->
        <dlnkpagination
            :page="reservations_page"
            :page_count="reservations_page_count"
            @next_page="next_reservation_page()"
            @prev_page="prev_reservation_page()"
            @set_page="set_reservation_page($event)">
        </dlnkpagination>
        <!-- End Pagination -->
      </div>

      <div class="tab-pane" id="waitings" role="tabpanel" aria-labelledby="books-tab">
        <!-- Pagination -->
        <div class="mt-2">
          <dlnkpagination
              :page="waitings_page"
              :page_count="waitings_page_count"
              @next_page="next_waiting_page()"
              @prev_page="prev_waiting_page()"
              @set_page="set_waiting_page($event)">
          </dlnkpagination>
        </div>
        <!-- End Pagination -->

        <!-- Waiting list -->
        <div class="tab-wrapper">

          <table class="table">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Événement</th>
              <th scope="col">Famille</th>
              <th scope="col">Prénom</th>
              <th scope="col">Nom</th>
              <th scope="col">Téléphone</th>
              <th scope="col">Age</th>
              <th scope="col">Date</th>
              <th scope="col">Action</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="waiting in waitings" :key="waitings.id">
              <th scope="row">
                {{ waiting.id }}
              </th>
              <td>{{ waiting.event }}</td>
              <td>{{ waiting.foyer }}</td>
              <td>{{ waiting.firstname }}</td>
              <td>{{ waiting.lastname }}</td>
              <td>{{ waiting.phone }}</td>
              <td>{{ waiting.age }}</td>
              <td>{{ waiting.created_at }}</td>
              <td>
                TODO
              </td>
            </tr>

            </tbody>
          </table>

        </div>
        <!-- End Loans  -->

        <!-- Pagination -->
        <dlnkpagination
            :page="waitings_page"
            :page_count="waitings_page_count"
            @next_page="next_waiting_page()"
            @prev_page="prev_waiting_page()"
            @set_page="set_waiting_page($event)">
        </dlnkpagination>

        <!-- End Pagination -->
      </div>

    </div>

  </div>


</template>

<script>

export default {

  props: [
  ],

  data: function () {
    return {
      events_page: Number,
      events: Array(),
      events_count: Number,
      events_page_count: Number,

      waitings_page: Number,
      waitings: Array(),
      waitings_count: Number,
      waitings_page_count: Number,

      reservations_page: Number,
      reservations: Array(),
      reservations_count: Number,
      reservations_page_count: Number,
      query: String,
      search_message: String,
      search_reservation_message: String,
      message: "",
      message_type: "",
    }
  },

  mounted() {
    this.events_page = 1
    this.waitings_page = 1
    this.reservations_page = 1
    this.message = ""
    this.message_type = ""
  },

  watch: {
    events_page: function (new_val, old_val) {
      if (new_val < 1) {
        this.events_page = 1
      }
      if (new_val > this.events_page_count) {
        this.events_page = this.events_page_count
      }
      this.get_events()
    },
    reservations_page: function (new_val, old_val) {
      if (new_val < 1) {
        this.reservations_page = 1
      }
      if (new_val > this.reservations_page_count) {
        this.reservations_page = this.reservations_page_count
      }
      this.get_reservations()
    },
    waitings_page: function (new_val, old_val) {
      if (new_val < 1) {
        this.waitings_page = 1
      }
      if (new_val > this.waitings_count) {
        this.waitings_page = this.waitings_count
      }
      this.get_waitings()
    },

  },

  methods: {

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },

    get_data: function () {
      this.get_events()
      this.get_waitings()
      this.get_reservations()
    },

    get_events: function () {
      const _this = this

      const url = '/modules/dlnkcalendar/actions/events.php?page=' + _this.events_page

      axios.get(url)
          .then(function (response) {
            _this.events = response.data.events
            _this.events_count = response.data.events_count
            _this.events_page_count = response.data.pages_count
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_reservations: function () {
      const _this = this

      const url = '/modules/dlnkcalendar/actions/reservations.php?page=' + _this.reservations_page

      axios.get(url)
          .then(function (response) {
            _this.reservations = response.data.reservations
            _this.reservations_count = response.data.reservations_count
            _this.reservations_page_count = response.data.pages_count
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_waitings: function () {
      const _this = this

      const url = '/modules/dlnkcalendar/actions/waitings.php?page=' + _this.waitings_page

      axios.get(url)
          .then(function (response) {
            _this.waitings = response.data.waitings
            _this.waitings_count = response.data.waitings_count
            _this.waitings_page_count = response.data.page_count
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    set_event_page: function (page) {
      page = parseInt(page)
      this.events_page = page
    },

    set_waiting_page: function (page) {
      page = parseInt(page)
      this.waitings_page = page
    },

    set_reservation_page: function (page) {
      page = parseInt(page)
      this.reservations_page = page
    },

    next_event_page: function () {
      this.events_page++
    },

    next_waiting_page: function () {
      this.waitings_page++
    },

    next_reservation_page: function () {
      this.reservations_page++
    },

    prev_event_page: function () {
      this.events_page--
    },

    prev_reservation_page: function () {
      this.reservations_page--
    },

    prev_waiting_page: function () {
      this.waitings_page--
    },

  }
}

</script>

<style scoped>

.tab-wrapper {
  border: 1px solid #e7eaf3;
  box-shadow: 0 0 35px rgba(140, 152, 163, .125);
  border-radius: .5rem;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
}

</style>